import React from 'react';

const HistoryLine = () => {
  return <hr className="history__line" />;
};

export default HistoryLine;
